import { IBillingService } from "../../../core/services/billing";
import { injectable } from "inversify";
import databaseInstance from "../../index";

@injectable()
export class BillingService implements IBillingService {
  private dbInstance: any = databaseInstance;

  private static instance: BillingService;

  constructor() {
    BillingService.instance = this;
  }

  public static getInstance() {
    if (!BillingService.instance) {
      BillingService.instance = new BillingService();
    }
    return BillingService.instance;
  }

  public getPlans: () => Promise<void> = () => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance.get("/subscription-plans").then((response: any) => {
        resolve(response);
      }).catch((error: any) => {
        reject(error)
        new Error("Something went wrong!")
      });
    });
  };

  public updateSubscription: (groupId: any, planId: any, couponCode: string | null, paymentId?: any) => Promise<void> = (
    groupId,
    planId,
    couponCode,
    paymentId
  ) => {
    return new Promise<void>((resolve, reject) => {
      let payload: any = {
        plan_id: planId,
      }

      if(couponCode) {
        payload = {
          ...payload,
          coupon_code: couponCode,
        }
      }

      if(paymentId) {
        payload.payment_method_id = paymentId
      }
      
      this.dbInstance
        .put(`/groups/${groupId}/subscriptions`, payload)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public cancelSubscription: (groupId: any, planId: any, payload?: any) => Promise<void> = (
    groupId,
    planId,
    payload
  ) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .delete(`/groups/${groupId}/subscriptions/${planId}`, { data: payload})
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public stopSubscriptionCancellation: (groupId: any, subscriptionId: any) => Promise<void> = (
    groupId,
    subscriptionId
  ) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .put(`/groups/${groupId}/subscriptions/${subscriptionId}/resume`)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public planSubscription: (
    groupId: any,
    planId: any,
    paymentId: any
  ) => Promise<void> = (groupId, planId, paymentId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/subscriptions`, {
          plan_id: planId,
          payment_method_id: paymentId
        })
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public getInvoices: (groupId: any) => Promise<void> = groupId => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/invoices`)
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public updatePaymentMethod: (
    groupId: any,
    paymentId: any
  ) => Promise<void> = (groupId, paymentId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .put(`/groups/${groupId}/payment-method`, {
          payment_method_id: paymentId
        })
        .then((response: any) => {
          resolve(response);
        }).catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  };

  public validateCouponCode: (
    code: string,
    planId: any,
    groupId?: number,
  ) => Promise<void> = (code, planId, groupId=-1) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/coupons/validate`, {
          code,
          group_id: groupId,
          plan_id: planId
        })
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public getAppSumoChangeTierCallback: (
    groupId: number,
  ) => Promise<void> = (groupId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/appsumo-change-tier`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public inviteUsersToGroupPlan: (
    groupId: number,
    membershipId: number,
    payload: any,
  ) => Promise<void> = (groupId, membershipId, payload) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/memberships/${membershipId}/subscription/invitations`, payload)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public getSubscriptionAmountPreview: (
    groupId: number,
    planId: number,
    quantity: number,
  ) => Promise<void> = (groupId, planId, quantity) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/subscription-preview`, {
          params: {
            plan_id: planId,
            quantity,
          }
        })
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }
}
